import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { expiryWindow, licenseViewStatus, licenseViews, type LicenseView } from "@/lib/license-views";

export function LicenseViewToolbar({ view, onSelect }: {
  view: LicenseView;
  onSelect: (params: URLSearchParams) => void;
}) {
  const { t } = useTranslation();
  const apply = (nextView: LicenseView) => {
    const params = new URLSearchParams();
    if (nextView !== "all") params.set("view", nextView);
    const nextStatus = licenseViewStatus(nextView, "all");
    // Non-default presets write status explicitly; the default "All licenses"
    // preset returns to the bare URL so the active default applies.
    if (nextView !== "all") params.set("status", nextStatus);
    if (nextView === "expiring") Object.entries(expiryWindow()).forEach(([key, value]) => params.set(key, value));
    onSelect(params);
  };
  return (
    <section className="flex shrink-0 flex-wrap items-center gap-2" aria-label={t("uxViews.label")}>
      <div className="flex flex-wrap items-center gap-2">
        {licenseViews.map((item) => (
          <Button key={item} variant="outline" aria-pressed={view === item} className={view === item ? "border-ink bg-ink text-canvas hover:bg-ink/90 hover:text-canvas" : undefined} onClick={() => apply(item)}>
            {t(`uxViews.${item}`)}
          </Button>
        ))}
      </div>
    </section>
  );
}
